import { render, staticRenderFns } from "./HisInformationItemSelector.vue?vue&type=template&id=d946be0c&"
import script from "./HisInformationItemSelector.vue?vue&type=script&lang=ts&"
export * from "./HisInformationItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports